import React, { useState, useEffect, useRef, useMemo } from "react";
import Select from "antd/lib/select";
import accoArrow from "../../../../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../../../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import {
  callNotification,
  getAllDeepDiveDashboardFilters,
  getAllFilters,
  getAllShareFilters,
  getAllTemplateFilters,
  getCombinedDate,
  getCustomizedDate,
  getGlobalBrands,
  getTimeIntervalDate,
  getWidgetGraphObject,
  getWindowLocationPath,
  useQuery,
} from "../../../../../redux/constants";
import { useDispatch, useSelector } from "react-redux";
import { getPaneIndex } from "../../../../../redux/constants";
import isEqual from "react-fast-compare";
import moment from "moment";
import { Tooltip } from "antd";
import {
  getDeepDive,
  setPageChart,
  setWidgetMakerGraphData,
  setWidgetMakerShareGraphData,
  setWidgetMakerSharePageGraphData,
} from "../../../../../redux/actions/WidgetMaker/WidgetAPI";
import {
  getAllWidgetScreenFilters,
  getScreenWidgetGraphObject,
} from "../../../../../redux/constants/commandCenterConstants";
import {
  setDateAggregation,
  setDateAggregationLoader,
} from "../../../../../redux/actions/commandCenter/screens/screen";
import { setScreenWidgetGraphData } from "../../../../../redux/actions/commandCenter/commandCenterApi";
import { getDynamicIconColor } from "../../../../../redux/constants/DynamicIconColor";
import { supportedBenchmarkTraceDashboardTypes } from "../../../../../redux/constants/enums";

const DateAggregation = ({
  section_index,
  widget_index,
  template_widget,
  widgetData,
  deepDive,
  widget_id,
  tabName,
  disabled = false,
}) => {
  let query = useQuery();
  const dateAggregationRef = useRef();
  const dispatch = useDispatch();
  const personalizationSettingsObj = useSelector(
    (state) => state?.PersonalizationSetting
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const { Option } = Select;
  const authParams = useSelector((state) => state.Authentication.authParams);
  const panes = useSelector((state) => state.Tab1.panes);
  const activeKey = useSelector((state) => state.Tab1.activeKey);
  const Section = useSelector((state) => state.Section.addSection);
  let index = getPaneIndex(panes, activeKey);
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const shareableLinkDeepDiveStatus = useSelector(
    (state) => state?.ApiCall?.shareableLinkDeepDiveStatus
  );
  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const sharedDuration = useSelector((state) => state.Share.sharedDuration);
  const global_dashboard_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_brands
  );

  const global_dashboard_single_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_single_brands
  );

  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );

  const selectedDate = panes[index].duration;
  const global_dashboard_duration = useSelector(
    (state) => state.AuthParams.global_dashboard_duration
  );
  const deepdive_object = useSelector(
    (state) => state?.WidgetMaker?.deepdive_object
  );
  const twitterTrendsData = useSelector(
    (state) => state?.Screens?.screen?.deep_dive?.twitter_trend
  );
  const screen = useSelector((state) => state?.Screens?.screen);

  const temporary_words = useSelector(
    (state) => state?.attributes?.temporary_words
  );
  const deepdiveDashboardData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardData
  );
  const deepdiveDashboardTemplateData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardTemplateData
  );
  const isDeepDiveViewOpened = useMemo(() => {
    let pathName = getWindowLocationPath()?.toLowerCase();
    return (
      (authParams?.screen_id
        ? screen?.isDeepDiveDashboard
          ? true
          : false
        : shareableLinkDeepDiveStatus
        ? shareTemplateData?.isDeepDiveDashboard
          ? true
          : false
        : !authParams?.screen_id &&
          !shareBrands &&
          (pathName === "dashboard" || pathName === "pin-dashboard") &&
          !panes?.[getPaneIndex(panes, activeKey)]?.is_widget_maker_open_obj
            ?.open_flag &&
          panes?.[getPaneIndex(panes, activeKey)]?.isDeepDiveDashboard
        ? true
        : false) && !deepdiveDashboardTemplateData?.isDeepDive
    );
  }, [
    screen,
    shareTemplateData,
    panes,
    authParams,
    deepdiveDashboardTemplateData,
  ]);

  const profileFilterList = isDeepDiveViewOpened
    ? deepdiveDashboardTemplateData?.profile_filters_list
    : window.location.pathname?.split("/")?.[1] === "edit-dashboard" ||
      window.location.pathname?.split("/")?.[1] === "create-dashboard"
    ? templateDetails?.profile_filters_list
    : panes?.[index]?.profile_filters_list;

  const [optionList, setOptionList] = useState([]);
  const [defaultOption, setDefaultOption] = useState([]);
  let yAxesDateAttr =
    widgetData?.y_axes && Array.isArray(widgetData?.y_axes)
      ? widgetData?.y_axes?.some(
          (y_axis) =>
            graphConditionConfig?.["date-attributes"]?.includes(
              y_axis?.attribute
            ) &&
            (!y_axis?.date_part || y_axis?.date_part === "D")
        )
        ? widgetData?.y_axes?.find(
            (y_axis) =>
              graphConditionConfig?.["date-attributes"]?.includes(
                y_axis?.attribute
              ) &&
              (!y_axis?.date_part || y_axis?.date_part === "D")
          )
        : null
      : null;
  let updatedDateAgg =
    deepDive &&
    authParams?.screen_id &&
    tabName === deepdive_object?.tabName &&
    !isDeepDiveViewOpened
      ? twitterTrendsData?.trendlineMentionsDateAggregation
      : yAxesDateAttr
      ? yAxesDateAttr?.date_aggregation
      : widgetData?.x_axis?.date_aggregation;
  let selectedMonthValue =
    deepDive && authParams?.screen_id && tabName === deepdive_object?.tabName
      ? twitterTrendsData?.selectedMonthValue
      : 1;

  useEffect(() => {
    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };

    let getInterval;
    let pathName = window.location.pathname?.split("/")?.[1];
    let command_center_screen_id = window?.location?.pathname?.split("/")?.[3];
    if (isDeepDiveViewOpened) {
      // DeepDive Dashboard View
      let section;
      let sectionStartDate;
      let sectionEndDate;
      let widgetStartDate;
      let widgetEndDate;
      let dashboardData = deepdiveDashboardData;
      let templateData = deepdiveDashboardTemplateData;
      section =
        templateData?.sections?.length > 0
          ? templateData?.sections?.[section_index]
          : null;
      if (section) {
        if (
          section?.widgets?.[widget_index]?.start_date &&
          section?.widgets?.[widget_index]?.is_locked
        ) {
          widgetStartDate = section?.widgets?.[widget_index]?.start_date;
          widgetEndDate = section?.widgets?.[widget_index]?.end_date;
        }
        // else {
        //   widgetStartDate = dashboardData?.duration?.from;
        //   widgetEndDate = dashboardData?.duration?.to;
        // }

        if (section?.start_date && section?.is_locked) {
          sectionStartDate = section?.start_date;
          sectionEndDate = section?.end_date;
        }
      }

      let global_date = {
        from: dashboardData?.duration?.from
          ? dashboardData?.duration?.from
          : dashboardData?.start_date
          ? dashboardData?.start_date
          : defaultDuration?.from,
        to: dashboardData?.duration?.to
          ? dashboardData?.duration?.to
          : dashboardData?.end_date
          ? dashboardData?.end_date
          : defaultDuration?.to,
      };
      let section_date = sectionStartDate && {
        from: sectionStartDate,
        to: sectionEndDate,
      };
      let widget_date = widgetStartDate && {
        from: widgetStartDate,
        to: widgetEndDate,
      };
      let filter_date = widget_date
        ? [widget_date]
        : section_date
        ? [section_date]
        : [];

      let combinedDate;
      combinedDate =
        section?.widgets?.[widget_index]?.is_locked && widget_date
          ? widget_date && getCombinedDate(null, [widget_date])
          : section?.is_locked && section_date
          ? section_date && getCombinedDate(null, [section_date])
          : global_date &&
            filter_date &&
            getCombinedDate(global_date, filter_date);

      let pageDataSource = graphConditionConfig?.[`default_attrs`]?.page
        ?.map((d) => d?.attribute)
        ?.includes(widgetData?.y_series?.[0]?.attribute)
        ? "page"
        : null;

      getInterval = getTimeIntervalDate(
        combinedDate?.end_date
          ? combinedDate?.end_date
          : global_date?.to
          ? global_date?.to
          : defaultDuration?.to,
        combinedDate?.start_date
          ? combinedDate?.start_date
          : global_date?.from
          ? global_date?.from
          : defaultDuration?.from,
        pageDataSource ? pageDataSource : widgetData?.data_source,
        yAxesDateAttr?.attribute
          ? yAxesDateAttr?.attribute
          : widgetData?.x_axis?.attribute
      );
    } else if (deepDive && command_center_screen_id) {
      // Command Center Screen DeepDive
      let deepdiveStartDate;
      let deepdiveEndDate;
      if (widget_id === "twitter-trends_3") {
        let durationOfLastMonthForWid = getCustomizedDate(
          selectedMonthValue,
          "Months"
        );
        let globalDateForInterestOvertime = {
          from:
            moment(durationOfLastMonthForWid?.date?.[0]).format("YYYY/MM/DD") +
            " " +
            durationOfLastMonthForWid?.time?.startTime,
          to:
            moment(durationOfLastMonthForWid?.date?.[1]).format("YYYY/MM/DD") +
            " " +
            durationOfLastMonthForWid?.time?.endTime,
        };
        deepdiveStartDate = globalDateForInterestOvertime?.from;
        deepdiveEndDate = globalDateForInterestOvertime?.to;
      } else if (screen?.duration?.from && screen?.duration?.to) {
        deepdiveStartDate = screen?.duration?.from;
        deepdiveEndDate = screen?.duration?.to;
      } else {
        deepdiveStartDate = defaultDuration?.from;
        deepdiveEndDate = defaultDuration?.to;
      }
      let global_date = {
        from: screen?.duration?.from
          ? screen?.duration?.from
          : defaultDuration?.from,
        to: screen?.duration?.to ? screen?.duration?.to : defaultDuration?.to,
      };

      let deepdive_date = deepdiveStartDate && {
        from: deepdiveStartDate,
        to: deepdiveEndDate,
      };
      let filter_date = deepdive_date ? [deepdive_date] : [];

      let combinedDate;
      combinedDate = deepdive_date
        ? getCombinedDate(null, [deepdive_date])
        : global_date &&
          filter_date &&
          getCombinedDate(global_date, filter_date);
      let pageDataSource = graphConditionConfig?.[`default_attrs`]?.page
        ?.map((d) => d?.attribute)
        ?.includes(deepdive_object?.deepdive_on?.y_series?.attribute)
        ? "page"
        : null;

      getInterval = getTimeIntervalDate(
        combinedDate?.end_date ? combinedDate?.end_date : defaultDuration?.to,
        combinedDate?.start_date
          ? combinedDate?.start_date
          : defaultDuration?.from,
        pageDataSource ? pageDataSource : deepdive_object?.data_source,
        yAxesDateAttr?.attribute
          ? yAxesDateAttr?.attribute
          : widgetData?.x_axis?.attribute
      );
    } else if (
      command_center_screen_id === "000-000-551" ||
      command_center_screen_id === "000-000-556" ||
      command_center_screen_id === "bb85d615-5e8f-4d1f-92f3-0c1749467137" ||
      command_center_screen_id === "000-000-564"
    ) {
      // Command Center Screen
      let widgetStartDate;
      let widgetEndDate;

      // console.log("Inside Screen Id", screen);
      if (
        screen?.widgets?.[widget_index]?.start_date &&
        screen?.widgets?.[widget_index]?.is_locked
      ) {
        widgetStartDate = screen?.widgets?.[widget_index]?.start_date;
        widgetEndDate = screen?.widgets?.[widget_index]?.end_date;
      }
      // else {
      //   widgetStartDate = screen?.duration?.from;
      //   widgetEndDate = screen?.duration?.to;
      // }

      let global_date = {
        from: screen?.duration?.from
          ? screen?.duration?.from
          : defaultDuration?.from,
        to: screen?.duration?.to ? screen?.duration?.to : defaultDuration?.to,
      };

      let widget_date = widgetStartDate && {
        from: widgetStartDate,
        to: widgetEndDate,
      };
      let filter_date = widget_date ? [widget_date] : [];

      let combinedDate;
      combinedDate = widget_date
        ? getCombinedDate(null, [widget_date])
        : global_date &&
          filter_date &&
          getCombinedDate(global_date, filter_date);

      let pageDataSource = graphConditionConfig?.[`default_attrs`]?.page
        ?.map((d) => d?.attribute)
        ?.includes(widgetData?.y_series?.[0]?.attribute)
        ? "page"
        : null;

      getInterval = getTimeIntervalDate(
        combinedDate?.end_date
          ? combinedDate?.end_date
          : selectedDate?.to
          ? selectedDate?.to
          : defaultDuration?.to,
        combinedDate?.start_date
          ? combinedDate?.start_date
          : selectedDate?.from
          ? selectedDate?.from
          : defaultDuration?.from,
        pageDataSource ? pageDataSource : widgetData?.data_source,
        yAxesDateAttr?.attribute
          ? yAxesDateAttr?.attribute
          : widgetData?.x_axis?.attribute
      );
    } else if (
      pathName === "edit-dashboard" ||
      pathName === "create-dashboard"
    ) {
      // Create and Edit Dashboard
      let sectionStartDate;
      let sectionEndDate;
      let widgetStartDate;
      let widgetEndDate;

      if (section_index >= 0) {
        if (
          Section?.[section_index]?.data?.[widget_index]?.start_date &&
          Section?.[section_index]?.data?.[widget_index]?.is_locked
        ) {
          widgetStartDate =
            Section?.[section_index]?.data?.[widget_index]?.start_date;
          widgetEndDate =
            Section?.[section_index]?.data?.[widget_index]?.end_date;
        }

        // else {
        //   widgetStartDate = templateDetails?.templateDuration?.from;
        //   widgetEndDate = templateDetails?.templateDuration?.to;
        // }

        if (
          Section?.[section_index]?.duration?.from &&
          Section?.[section_index]?.duration?.is_locked
        ) {
          sectionStartDate = Section?.[section_index]?.duration?.from;
          sectionEndDate = Section?.[section_index]?.duration?.to;
        }
      } else {
        if (
          Section?.[0]?.data?.[widget_index]?.start_date &&
          Section?.[0]?.data?.[widget_index]?.is_locked
        ) {
          widgetStartDate = Section?.[0]?.widgets?.[widget_index]?.start_date;
          widgetEndDate = Section?.[0]?.widgets?.[widget_index]?.end_date;
        }

        // else {
        //   widgetStartDate = templateDetails?.templateDuration?.from;
        //   widgetEndDate = templateDetails?.templateDuration?.to;
        // }

        if (Section?.[0]?.duration?.from && Section?.[0]?.duration?.is_locked) {
          sectionStartDate = Section?.[0]?.duration?.from;
          sectionEndDate = Section?.[0]?.duration?.to;
        }
      }

      let global_date = {
        from: templateDetails?.templateDuration?.from
          ? templateDetails?.templateDuration?.from
          : defaultDuration?.from,
        to: templateDetails?.templateDuration?.to
          ? templateDetails?.templateDuration?.to
          : defaultDuration?.to,
      };
      let section_date = sectionStartDate && {
        from: sectionStartDate,
        to: sectionEndDate,
      };
      let widget_date = widgetStartDate && {
        from: widgetStartDate,
        to: widgetEndDate,
      };
      let filter_date = widget_date
        ? [widget_date]
        : section_date
        ? [section_date]
        : [];

      let combinedDate;
      if (section_index >= 0) {
        combinedDate =
          Section?.[section_index]?.data?.[widget_index]?.is_locked &&
          widget_date
            ? widget_date && getCombinedDate(null, [widget_date])
            : Section?.[section_index]?.is_locked && section_date
            ? section_date && getCombinedDate(null, [section_date])
            : global_date &&
              filter_date &&
              getCombinedDate(global_date, filter_date);
      } else {
        combinedDate =
          Section?.[0]?.data?.[widget_index]?.is_locked && widget_date
            ? widget_date && getCombinedDate(null, [widget_date])
            : Section?.[0]?.is_locked && section_date
            ? section_date && getCombinedDate(null, [section_date])
            : global_date &&
              filter_date &&
              getCombinedDate(global_date, filter_date);
      }

      let pageDataSource = graphConditionConfig?.[`default_attrs`]?.page
        ?.map((d) => d?.attribute)
        ?.includes(widgetData?.y_series?.[0]?.attribute)
        ? "page"
        : null;

      getInterval = getTimeIntervalDate(
        combinedDate?.end_date
          ? combinedDate?.end_date
          : templateDetails?.templateDuration?.to
          ? templateDetails?.templateDuration?.to
          : defaultDuration?.to,
        combinedDate?.start_date
          ? combinedDate?.start_date
          : templateDetails?.templateDuration?.from
          ? templateDetails?.templateDuration?.from
          : defaultDuration?.from,
        pageDataSource ? pageDataSource : widgetData?.data_source,
        yAxesDateAttr?.attribute
          ? yAxesDateAttr?.attribute
          : widgetData?.x_axis?.attribute
      );
    } else if (shareTemplateData) {
      let sectionStartDate;
      let sectionEndDate;
      let widgetStartDate;
      let widgetEndDate;

      if (section_index >= 0) {
        if (
          shareTemplateData?.sections?.[section_index]?.widgets?.[widget_index]
            ?.start_date &&
          shareTemplateData?.sections?.[section_index]?.widgets?.[widget_index]
            ?.is_locked
        ) {
          widgetStartDate =
            shareTemplateData?.sections?.[section_index]?.widgets?.[
              widget_index
            ]?.start_date;
          widgetEndDate =
            shareTemplateData?.sections?.[section_index]?.widgets?.[
              widget_index
            ]?.end_date;
        }
        // else {
        //   widgetStartDate = sharedDuration?.from;
        //   widgetEndDate = sharedDuration?.to;
        // }

        if (
          shareTemplateData?.sections?.[section_index]?.start_date &&
          shareTemplateData?.sections?.[section_index]?.is_locked
        ) {
          sectionStartDate =
            shareTemplateData?.sections?.[section_index]?.start_date;
          sectionEndDate =
            shareTemplateData?.sections?.[section_index]?.end_date;
        }
      } else {
        if (
          shareTemplateData?.section?.[0]?.widgets?.[widget_index]
            ?.start_date &&
          shareTemplateData?.section?.[0]?.widgets?.[widget_index]?.is_locked
        ) {
          widgetStartDate =
            shareTemplateData?.section?.[0]?.widgets?.[widget_index]
              ?.start_date;
          widgetEndDate =
            shareTemplateData?.section?.[0]?.widgets?.[widget_index]?.end_date;
        }

        // else {
        //   widgetStartDate = sharedDuration?.from;
        //   widgetEndDate = sharedDuration?.to;
        // }

        if (
          shareTemplateData?.section?.[0]?.start_date &&
          shareTemplateData?.section?.[0]?.is_locked
        ) {
          sectionStartDate = shareTemplateData?.section?.[0]?.start_date;
          sectionEndDate = shareTemplateData?.section?.[0]?.end_date;
        }
      }

      let global_date = {
        from: sharedDuration?.from
          ? sharedDuration?.from
          : defaultDuration?.from,
        to: sharedDuration?.to ? sharedDuration?.to : defaultDuration?.to,
      };
      let section_date = sectionStartDate && {
        from: sectionStartDate,
        to: sectionEndDate,
      };
      let widget_date = widgetStartDate && {
        from: widgetStartDate,
        to: widgetEndDate,
      };
      let filter_date = widget_date
        ? [widget_date]
        : section_date
        ? [section_date]
        : [];

      let combinedDate;
      if (section_index >= 0) {
        combinedDate =
          shareTemplateData?.sections?.[section_index]?.widgets?.[widget_index]
            ?.is_locked && widget_date
            ? widget_date && getCombinedDate(null, [widget_date])
            : shareTemplateData?.sections?.[section_index]?.is_locked &&
              section_date
            ? section_date && getCombinedDate(null, [section_date])
            : global_date &&
              filter_date &&
              getCombinedDate(global_date, filter_date);
      } else {
        combinedDate =
          shareTemplateData?.section?.[0]?.widgets?.[widget_index]?.is_locked &&
          widget_date
            ? widget_date && getCombinedDate(null, [widget_date])
            : shareTemplateData?.section?.[0]?.is_locked && section_date
            ? section_date && getCombinedDate(null, [section_date])
            : global_date &&
              filter_date &&
              getCombinedDate(global_date, filter_date);
      }

      let pageDataSource = graphConditionConfig?.[`default_attrs`]?.page
        ?.map((d) => d?.attribute)
        ?.includes(widgetData?.y_series?.[0]?.attribute)
        ? "page"
        : null;

      getInterval = getTimeIntervalDate(
        combinedDate?.end_date
          ? combinedDate?.end_date
          : sharedDuration?.to
          ? sharedDuration?.to
          : defaultDuration?.to,
        combinedDate?.start_date
          ? combinedDate?.start_date
          : sharedDuration?.from
          ? sharedDuration?.from
          : defaultDuration?.from,
        pageDataSource ? pageDataSource : widgetData?.data_source,
        yAxesDateAttr?.attribute
          ? yAxesDateAttr?.attribute
          : widgetData?.x_axis?.attribute
      );
    } else {
      // View Dashboard
      let sectionStartDate;
      let sectionEndDate;
      let widgetStartDate;
      let widgetEndDate;

      if (section_index >= 0) {
        if (
          panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
            ?.start_date &&
          panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
            ?.is_locked
        ) {
          widgetStartDate =
            panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
              ?.start_date;
          widgetEndDate =
            panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
              ?.end_date;
        }

        // else {
        //   widgetStartDate = panes?.[index]?.duration?.from;
        //   widgetEndDate = panes?.[index]?.duration?.to;
        // }

        if (
          panes?.[index]?.sections?.[section_index]?.start_date &&
          panes?.[index]?.sections?.[section_index]?.is_locked
        ) {
          sectionStartDate =
            panes?.[index]?.sections?.[section_index]?.start_date;
          sectionEndDate = panes?.[index]?.sections?.[section_index]?.end_date;
        }
      } else {
        if (
          panes?.[index]?.section?.[0]?.widgets?.[widget_index]?.start_date &&
          panes?.[index]?.section?.[0]?.widgets?.[widget_index]?.is_locked
        ) {
          widgetStartDate =
            panes?.[index]?.section?.[0]?.widgets?.[widget_index]?.start_date;
          widgetEndDate =
            panes?.[index]?.section?.[0]?.widgets?.[widget_index]?.end_date;
        }

        // else {
        //   widgetStartDate = panes?.[index]?.duration?.from;
        //   widgetEndDate = panes?.[index]?.duration?.to;
        // }

        if (
          panes?.[index]?.section?.[0]?.start_date &&
          panes?.[index]?.section?.[0]?.is_locked
        ) {
          sectionStartDate = panes?.[index]?.section?.[0]?.start_date;
          sectionEndDate = panes?.[index]?.section?.[0]?.end_date;
        }
      }

      let global_date = {
        from: panes?.[index]?.duration?.from
          ? panes?.[index]?.duration?.from
          : defaultDuration?.from,
        to: panes?.[index]?.duration?.to
          ? panes?.[index]?.duration?.to
          : defaultDuration?.to,
      };
      let section_date = sectionStartDate && {
        from: sectionStartDate,
        to: sectionEndDate,
      };
      let widget_date = widgetStartDate && {
        from: widgetStartDate,
        to: widgetEndDate,
      };
      let filter_date = widget_date
        ? [widget_date]
        : section_date
        ? [section_date]
        : [];

      let combinedDate;
      if (section_index >= 0) {
        combinedDate =
          panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
            ?.is_locked && widget_date
            ? widget_date && getCombinedDate(null, [widget_date])
            : panes?.[index]?.sections?.[section_index]?.is_locked &&
              section_date
            ? section_date && getCombinedDate(null, [section_date])
            : global_date &&
              filter_date &&
              getCombinedDate(global_date, filter_date);
      } else {
        combinedDate =
          panes?.[index]?.section?.[0]?.widgets?.[widget_index]?.is_locked &&
          widget_date
            ? widget_date && getCombinedDate(null, [widget_date])
            : panes?.[index]?.section?.[0]?.is_locked && section_date
            ? section_date && getCombinedDate(null, [section_date])
            : global_date &&
              filter_date &&
              getCombinedDate(global_date, filter_date);
      }

      let pageDataSource = graphConditionConfig?.[`default_attrs`]?.page
        ?.map((d) => d?.attribute)
        ?.includes(widgetData?.y_series?.[0]?.attribute)
        ? "page"
        : null;

      getInterval = getTimeIntervalDate(
        combinedDate?.end_date
          ? combinedDate?.end_date
          : selectedDate?.to
          ? selectedDate?.to
          : defaultDuration?.to,
        combinedDate?.start_date
          ? combinedDate?.start_date
          : selectedDate?.from
          ? selectedDate?.from
          : defaultDuration?.from,
        pageDataSource ? pageDataSource : widgetData?.data_source,
        yAxesDateAttr?.attribute
          ? yAxesDateAttr?.attribute
          : widgetData?.x_axis?.attribute
      );
    }

    setOptionList(getInterval?.timeList);
    setDefaultOption(getInterval?.defaultVal);
  }, [
    selectedDate,
    widgetData?.data_source,
    Section,
    screen,
    isDeepDiveViewOpened,
  ]);
  const handleChangeDuration = (
    value,
    widgetData,
    section_index,
    widget_index
  ) => {
    let pathName = window.location.pathname?.split("/")?.[1];
    let command_center_screen_id = window?.location?.pathname?.split("/")?.[3];
    if (isDeepDiveViewOpened) {
      // view dashboard
      let finalDatePart = value === "D" ? null : value;
      let updatedXaxis;
      let updatedYaxis = [];
      if (
        graphConditionConfig?.[`date-attributes`]?.includes(
          widgetData?.x_axis?.attribute
        ) &&
        (!widgetData?.x_axis?.date_part ||
          widgetData?.x_axis?.date_part === "D")
      ) {
        updatedXaxis = {
          ...widgetData?.x_axis,
          date_aggregation: finalDatePart,
        };
      }
      if (
        graphConditionConfig?.[`date_agg-chart_type`]?.includes(
          widgetData?.chart?.chart_type || widgetData?.graph_type
        ) &&
        widgetData?.y_axes?.some(
          (y_axis) =>
            graphConditionConfig?.["date-attributes"]?.includes(
              y_axis?.attribute
            ) &&
            (!y_axis?.date_part || y_axis?.date_part === "D")
        )
      ) {
        widgetData?.y_axes?.forEach((y_axis) => {
          if (
            graphConditionConfig?.[`date-attributes`]?.includes(
              y_axis?.attribute
            ) &&
            (!y_axis?.date_part || y_axis?.date_part === "D")
          ) {
            y_axis.date_aggregation = finalDatePart;
          }
          updatedYaxis?.push(y_axis);
        });
      }
      if (widgetData) {
        let dashboardData = deepdiveDashboardData;
        let templateData = deepdiveDashboardTemplateData;
        let section =
          templateData?.sections?.length > 0
            ? templateData?.sections?.[section_index]
            : null;
        let duration = dashboardData?.duration
          ? dashboardData?.duration
          : dashboardData?.from
          ? {
              from: dashboardData?.from,
              to: dashboardData?.to,
            }
          : dashboardData?.start_date
          ? {
              from: dashboardData?.start_date,
              to: dashboardData?.end_date,
            }
          : null;

        let global_brands = dashboardData?.brands;
        let brandsContainter = {
          brand_ids: widgetData?.brand_ids,
          brand_groups: widgetData?.brand_groups,
          singleBrands: brands,
          brandGroupList: brandlogicalgroup,
        };
        let filter = getAllDeepDiveDashboardFilters(
          graphConditionConfig,
          dashboardData,
          deepdiveDashboardTemplateData,
          section_index,
          widget_index,
          brandsContainter
        );
        let indexes = {
          section_index: section_index,
          widget_index: widget_index,
          widget_id: widgetData?.widget_id ? widgetData?.widget_id : widget_id,
          graph_type: widgetData?.graph_type,
          section_id: section?.section_id,
          deepdiveDashboardTemplateData: templateData,
          deepdiveDashboardData: deepdiveDashboardData,
          isDeepdiveDashboard: true,
        };

        // View Dashboard Profile FIlter case
        let widget_metadata = section?.widgets?.[widget_index];

        let widget_profile_filter_list = widget_metadata?.profile_filters_list;

        let section_profile_filter_list = section?.profile_filters_list;

        let obj = {};
        obj.section_index = section_index;
        obj.widget_index = widget_index;
        obj.data = widgetData;
        obj.deepdiveDashboardData = deepdiveDashboardData;
        obj.deepdiveDashboardTemplateData = deepdiveDashboardTemplateData;
        obj.duration = duration;
        obj.global_brands = global_brands;
        obj.filter = filter;
        obj.temporary_words = temporary_words;
        obj.brandlogicalgroup = brandlogicalgroup;
        obj.brands = brands;
        obj.graphConditionConfig = graphConditionConfig;
        obj.authParams = authParams;
        obj.type = "deepdive_dashboard";
        obj.profile_filters = widget_metadata?.profile_filters
          ? widget_metadata?.profile_filters
          : null;
        obj.profile_filters_list =
          widget_metadata?.is_locked && widget_profile_filter_list?.length > 0
            ? widget_profile_filter_list
            : section_profile_filter_list?.length > 0
            ? section_profile_filter_list
            : profileFilterList;
        obj.profile_filters_flag = widget_metadata?.profile_filters_flag;
        obj.filter_by_data = widget_metadata?.filter_by_data;
        obj.filter_by = widget_metadata?.filter_by;

        obj.filter_dropdown = widget_metadata?.filter_dropdown
          ? widget_metadata?.filter_dropdown
          : [];
        obj.filter_by_dropdown = widget_metadata?.filter_by_dropdown
          ? widget_metadata?.filter_by_dropdown
          : [];
        obj.filter_by_dropdown_data = widget_metadata?.filter_by_dropdown_data
          ? widget_metadata?.filter_by_dropdown_data
          : [];

        let widgetGraphObject = getWidgetGraphObject(obj);
        widgetGraphObject.isNetworkChartV2 =
          widgetGraphObject?.chart?.chart_type === "network-graph-v2"
            ? true
            : false;
        if (widgetGraphObject && updatedXaxis) {
          widgetGraphObject.x_axis = updatedXaxis;
        }
        if (widgetGraphObject && updatedYaxis?.length) {
          widgetGraphObject.y_axes = updatedYaxis;
        }
        if (section_index >= 0) {
          if (updatedXaxis) {
            deepdiveDashboardTemplateData.sections[section_index].widgets[
              widget_index
            ].x_axis = updatedXaxis;
          }
          if (updatedYaxis?.length) {
            deepdiveDashboardTemplateData.sections[section_index].widgets[
              widget_index
            ].y_axes = updatedYaxis;
          }
          if (!shareBrands) {
            if (
              graphConditionConfig?.[`data-source`]?.includes(
                widgetData?.data_source
              )
            ) {
              dispatch(setPageChart(authParams, widgetGraphObject, indexes));
            } else {
              dispatch(
                setWidgetMakerGraphData(authParams, widgetGraphObject, indexes)
              );
            }
          } else {
            indexes.shareBrands = shareBrands;
            if (
              graphConditionConfig?.[`data-source`]?.includes(
                widgetData?.data_source
              )
            ) {
              dispatch(
                setWidgetMakerSharePageGraphData(
                  widgetGraphObject,
                  shareCategory,
                  indexes,
                  null,
                  query?.get("share_id")
                )
              );
            } else {
              dispatch(
                setWidgetMakerShareGraphData(
                  widgetGraphObject,
                  shareCategory,
                  indexes,
                  null,
                  query?.get("share_id")
                )
              );
            }
          }
        }
      }
    } else if (deepDive && command_center_screen_id) {
      // command center twitter trend deepdive
      let widget_ids = [widget_id];
      let finalDatePart = value === "D" ? null : value;
      let updatedXaxis = {
        ...deepdive_object?.deepdive_on?.x_axis,
        date_part: finalDatePart,
      };
      let updatedDeepDiveObj = structuredClone(deepdive_object);
      if (updatedDeepDiveObj) {
        // assign duration as per selectedMonthValue
        let selectedDuration;
        if (widget_id === "twitter-trends_3") {
          let durationOfLastMonthForWid = getCustomizedDate(
            selectedMonthValue ? selectedMonthValue : 1,
            "Months"
          );
          selectedDuration = {
            from:
              moment(durationOfLastMonthForWid?.date?.[0]).format(
                "YYYY/MM/DD"
              ) +
              " " +
              durationOfLastMonthForWid?.time?.startTime,
            to:
              moment(durationOfLastMonthForWid?.date?.[1]).format(
                "YYYY/MM/DD"
              ) +
              " " +
              durationOfLastMonthForWid?.time?.endTime,
          };
          updatedDeepDiveObj = {
            ...updatedDeepDiveObj,
            start_date: selectedDuration?.from,
            end_date: selectedDuration?.to,
            isDurationModified: true,
          };
        }

        updatedDeepDiveObj = {
          ...updatedDeepDiveObj,
          deepdive_on: {
            ...updatedDeepDiveObj?.deepdive_on,
            x_axis: {
              ...updatedXaxis,
            },
          },
          screen: screen,
        };
        let deep_dive_obj = {};
        if (widget_id === "twitter-trends_3") {
          let updatedTwitterTrend = {};
          updatedTwitterTrend.trendlineMentions = null;
          updatedTwitterTrend.trendlineMentionsDateAggregation = finalDatePart;

          deep_dive_obj.twitter_trend = updatedTwitterTrend;
          dispatch({
            type: "SET_DEEP_DIVE_DATA_IN_SCREEN_FOR_TWITTER_TREND",
            isDeepDive: true,
            deep_dive: deep_dive_obj,
          });
        }
        dispatch(getDeepDive(authParams, updatedDeepDiveObj, widget_ids));
      }
    } else if (
      command_center_screen_id === "000-000-551" ||
      command_center_screen_id === "000-000-556" ||
      command_center_screen_id === "bb85d615-5e8f-4d1f-92f3-0c1749467137" ||
      command_center_screen_id === "000-000-564"
    ) {
      // view dashboard
      let finalDatePart = value === "D" ? null : value;
      let updatedXaxis;
      let updatedYaxis = [];
      if (
        graphConditionConfig?.[`date-attributes`]?.includes(
          widgetData?.x_axis?.attribute
        ) &&
        (!widgetData?.x_axis?.date_part ||
          widgetData?.x_axis?.date_part === "D")
      ) {
        updatedXaxis = {
          ...widgetData?.x_axis,
          date_aggregation: finalDatePart,
        };
      }
      if (
        graphConditionConfig?.[`date_agg-chart_type`]?.includes(
          widgetData?.chart?.chart_type || widgetData?.graph_type
        ) &&
        widgetData?.y_axes?.some(
          (y_axis) =>
            graphConditionConfig?.["date-attributes"]?.includes(
              y_axis?.attribute
            ) &&
            (!y_axis?.date_part || y_axis?.date_part === "D")
        )
      ) {
        widgetData?.y_axes?.forEach((y_axis) => {
          if (
            graphConditionConfig?.[`date-attributes`]?.includes(
              y_axis?.attribute
            ) &&
            (!y_axis?.date_part || y_axis?.date_part === "D")
          ) {
            y_axis.date_aggregation = finalDatePart;
          }
          updatedYaxis?.push(y_axis);
        });
      }
      if (widgetData) {
        // Enable loader here
        if (
          authParams?.screen_id === "000-000-551" ||
          authParams?.screen_id === "000-000-556" ||
          authParams?.screen_id === "000-000-564"
        ) {
          dispatch(setDateAggregationLoader(true));
        }
        // Disabled loader in chart api call

        let filter = getAllWidgetScreenFilters(
          screen,
          section_index,
          widget_index,
          brands,
          brandlogicalgroup,
          widgetData
        );
        let duration = screen?.duration;
        let global_brands = screen?.brands;

        let indexes = {
          section_index: section_index,
          screen: screen,
          widget_index: widget_index,
          widget_id: widgetData?.widget_id ? widgetData?.widget_id : null,
          graph_type: widgetData?.graph_type,
          section_id: screen?.section_id,
        };

        let obj = {};
        obj.section_index = section_index;
        obj.widget_index = widget_index;
        obj.data = widgetData;
        obj.widget = widgetData;
        obj.screen = screen;
        obj.paneIndex = index;
        obj.duration = duration;
        obj.global_brands = global_brands;
        obj.filter = filter;
        obj.brandlogicalgroup = brandlogicalgroup;
        obj.brands = brands;
        obj.graphConditionConfig = graphConditionConfig;
        obj.authParams = authParams;
        obj.type = "commandCenter";

        obj.filter_dropdown = widgetData?.filter_dropdown
          ? widgetData?.filter_dropdown
          : [];
        obj.filter_by_dropdown = widgetData?.filter_by_dropdown
          ? widgetData?.filter_by_dropdown
          : [];
        obj.filter_by_dropdown_data = widgetData?.filter_by_dropdown_data
          ? widgetData?.filter_by_dropdown_data
          : [];

        let widgetGraphObject = getScreenWidgetGraphObject(obj);
        if (widgetGraphObject && updatedXaxis) {
          widgetGraphObject.x_axis = updatedXaxis;
        }
        if (widgetGraphObject && updatedYaxis?.length) {
          widgetGraphObject.y_axes = updatedYaxis;
        }
        if (section_index >= 0) {
          if (updatedXaxis) {
            screen.sections[section_index].widgets[widget_index].x_axis =
              updatedXaxis;
          }
          if (updatedYaxis?.length) {
            screen.sections[section_index].widgets[widget_index].y_axes =
              updatedYaxis;
          }
          dispatch(
            setScreenWidgetGraphData(authParams, widgetGraphObject, indexes)
          );
        } else if (screen.section) {
          if (updatedXaxis) {
            screen.section[0].widgets[widget_index].x_axis = updatedXaxis;
          }
          if (updatedYaxis?.length) {
            screen.section[0].widgets[widget_index].y_axes = updatedYaxis;
          }
          dispatch(
            setScreenWidgetGraphData(authParams, widgetGraphObject, indexes)
          );
        } else {
          if (updatedXaxis) {
            screen.widgets[widget_index].x_axis = updatedXaxis;
          }
          if (updatedYaxis?.length) {
            screen.widgets[widget_index].y_axes = updatedYaxis;
          }

          dispatch(
            setScreenWidgetGraphData(authParams, widgetGraphObject, indexes)
          );
        }
      }

      // let finalDatePart = value === "D" ? null : value;
      // dispatch(
      //   setDateAggregation(
      //     section_index >= 0 ? section_index : null,
      //     widget_index,
      //     "x_axis",
      //     finalDatePart
      //   )
      // );
    } else if (
      pathName === "edit-dashboard" ||
      pathName === "create-dashboard"
    ) {
      // edit and create
      let finalDatePart = value === "D" ? null : value;
      let updatedXaxis;
      let updatedYaxis = [];
      if (
        graphConditionConfig?.[`date-attributes`]?.includes(
          widgetData?.x_axis?.attribute
        ) &&
        (!widgetData?.x_axis?.date_part ||
          widgetData?.x_axis?.date_part === "D")
      ) {
        updatedXaxis = {
          ...widgetData?.x_axis,
          date_aggregation: finalDatePart,
        };
      }
      if (
        graphConditionConfig?.[`date_agg-chart_type`]?.includes(
          widgetData?.chart?.chart_type || widgetData?.graph_type
        ) &&
        widgetData?.y_axes?.some(
          (y_axis) =>
            graphConditionConfig?.["date-attributes"]?.includes(
              y_axis?.attribute
            ) &&
            (!y_axis?.date_part || y_axis?.date_part === "D")
        )
      ) {
        widgetData?.y_axes?.forEach((y_axis) => {
          if (
            graphConditionConfig?.[`date-attributes`]?.includes(
              y_axis?.attribute
            ) &&
            (!y_axis?.date_part || y_axis?.date_part === "D")
          ) {
            y_axis.date_aggregation = finalDatePart;
          }
          updatedYaxis?.push(y_axis);
        });
      }

      let duration = templateDetails?.templateDuration
        ? templateDetails?.templateDuration
        : panes[index]?.duration;

      let global_brands =
        templateDetails?.templateBrands?.columns?.length > 0
          ? templateDetails?.templateBrands?.columns
          : templateDetails?.templateBrands?.length > 0
          ? templateDetails?.templateBrands
          : null;
      let sectionObj = {
        filters: templateDetails?.templateFilters,
        quick_filter_value: templateDetails?.quick_filter_value,
        hidden_filter: templateDetails?.hidden_filter,
        adsset_value: templateDetails?.adsset_value,
        ads_value: templateDetails?.ads_value,
      };
      let filter = getAllTemplateFilters(
        graphConditionConfig,
        Section,
        section_index,
        widget_index,
        sectionObj
      );
      if (widgetData) {
        let indexes = {
          section_index: section_index >= 0 ? section_index : null,
          templateFilter: true,
          widget_index: widget_index,
          widget_id: widgetData?.widget_id,
          section: Section,
          graph_type: widgetData?.graph_type,
          section_id:
            section_index >= 0
              ? Section?.[section_index]?.id
              : Section?.[0]?.id,
          template_details: templateDetails,
        };
        let sectionObjN = {
          brandFilters: Section?.[section_index ? section_index : 0]
            ?.brandFilters
            ? Section?.[section_index ? section_index : 0]?.brandFilters
            : [],
          filters: Section?.[section_index ? section_index : 0]?.filters
            ? Section?.[section_index ? section_index : 0]?.filters
            : [],
          duration: Section?.[section_index ? section_index : 0]?.duration
            ? Section?.[section_index ? section_index : 0]?.duration
            : null,
          dateFilters: Section?.[section_index ? section_index : 0]?.dateFilters
            ? Section?.[section_index ? section_index : 0]?.dateFilters
            : [],
          is_locked: Section?.[section_index ? section_index : 0]?.is_locked
            ? Section?.[section_index ? section_index : 0]?.is_locked
            : false,
          quick_filter_value: templateDetails?.quick_filter_value,
        };
        let widgetObj = {
          filters: widgetData?.filters ? widgetData?.filters : [],
          duration: {
            from: widgetData?.start_date
              ? widgetData?.start_date
              : widgetData?.dateFilters?.from
              ? widgetData?.dateFilters?.from
              : null,
            to: widgetData?.end_date
              ? widgetData?.end_date
              : widgetData?.dateFilters?.to
              ? widgetData?.dateFilters?.to
              : null,
          },
          is_locked: widgetData?.is_locked ? widgetData?.is_locked : false,
        };

        // edit dashboard profile filters
        let widget_metadata =
          section_index >= 0
            ? Section?.[section_index]?.data?.[widget_index]
            : Section?.[0]?.data?.[widget_index];

        let widget_profile_filter_list =
          section_index >= 0
            ? Section?.[section_index]?.data?.[widget_index]
                ?.profile_filters_list
            : Section?.[0]?.data?.[widget_index]?.profile_filters_list;

        let section_profile_filter_list =
          section_index >= 0
            ? Section?.[section_index]?.profile_filters_list
            : Section?.[0]?.profile_filters_list;

        let obj = {};
        obj.section_index = section_index >= 0 ? section_index : null;
        obj.widget_index = widget_index;

        obj.competition_aggregation =
          supportedBenchmarkTraceDashboardTypes?.includes(
            templateDetails?.template_type
          )
            ? templateDetails?.competition_aggregation || "avg"
            : null;
        obj.template_type = templateDetails?.template_type;
        obj.public_engagement_only =
          templateDetails?.public_engagement_only || false;
        obj.duration = duration;
        obj.global_brands = global_brands;
        obj.filter = filter;
        obj.widget = widgetData;
        obj.brandlogicalgroup = brandlogicalgroup?.length
          ? brandlogicalgroup
          : null;
        obj.brands = brands?.length ? brands : null;
        obj.authParams = authParams;
        obj.sectionObj = sectionObjN;
        obj.widgetObj = widgetObj;
        obj.type = "template";
        obj.profile_filters = widget_metadata?.profile_filters
          ? widget_metadata?.profile_filters
          : null;
        obj.profile_filters_list =
          widget_metadata?.is_locked && widget_profile_filter_list?.length > 0
            ? widget_profile_filter_list
            : section_profile_filter_list?.length > 0
            ? section_profile_filter_list
            : profileFilterList;
        obj.profile_filters_flag = widget_metadata?.profile_filters_flag;
        obj.data_source = widgetData?.data_source
          ? widgetData?.data_source
          : "mentions";

        obj.filter_dropdown = widget_metadata?.filter_dropdown
          ? widget_metadata?.filter_dropdown
          : [];
        obj.filter_by_dropdown = widget_metadata?.filter_by_dropdown
          ? widget_metadata?.filter_by_dropdown
          : [];
        obj.filter_by_dropdown_data = widget_metadata?.filter_by_dropdown_data
          ? widget_metadata?.filter_by_dropdown_data
          : [];

        let widgetGraphObject = getWidgetGraphObject(obj);
        widgetGraphObject.isNetworkChartV2 =
          widgetGraphObject?.chart?.chart_type === "network-graph-v2"
            ? true
            : false;

        if (widgetGraphObject && updatedXaxis) {
          widgetGraphObject.x_axis = updatedXaxis;
        }
        if (widgetGraphObject && updatedYaxis?.length) {
          widgetGraphObject.y_axes = updatedYaxis;
        }
        if (section_index >= 0) {
          if (updatedXaxis) {
            Section[section_index].data[widget_index].x_axis = updatedXaxis;
          }
          if (updatedYaxis?.length) {
            Section[section_index].data[widget_index].y_axes = updatedYaxis;
          }

          if (
            graphConditionConfig?.[`data-source`]?.includes(
              widgetData?.data_source
            )
          ) {
            dispatch(setPageChart(authParams, widgetGraphObject, indexes));
          } else {
            dispatch(
              setWidgetMakerGraphData(authParams, widgetGraphObject, indexes)
            );
          }
        } else {
          if (updatedXaxis) {
            Section[0].data[widget_index].x_axis = updatedXaxis;
          }
          if (updatedYaxis?.length) {
            Section[0].data[widget_index].y_axes = updatedYaxis;
          }
          if (
            graphConditionConfig?.[`data-source`]?.includes(
              widgetData?.data_source
            )
          ) {
            dispatch(setPageChart(authParams, widgetGraphObject, indexes));
          } else {
            dispatch(
              setWidgetMakerGraphData(authParams, widgetGraphObject, indexes)
            );
          }
        }
      }
    } else if (shareTemplateData) {
      // share dashboard
      let finalDatePart = value === "D" ? null : value;
      let updatedXaxis;
      let updatedYaxis = [];
      if (
        graphConditionConfig?.[`date-attributes`]?.includes(
          widgetData?.x_axis?.attribute
        ) &&
        (!widgetData?.x_axis?.date_part ||
          widgetData?.x_axis?.date_part === "D")
      ) {
        updatedXaxis = {
          ...widgetData?.x_axis,
          date_aggregation: finalDatePart,
        };
      }
      if (
        graphConditionConfig?.[`date_agg-chart_type`]?.includes(
          widgetData?.chart?.chart_type || widgetData?.graph_type
        ) &&
        widgetData?.y_axes?.some(
          (y_axis) =>
            graphConditionConfig?.["date-attributes"]?.includes(
              y_axis?.attribute
            ) &&
            (!y_axis?.date_part || y_axis?.date_part === "D")
        )
      ) {
        widgetData?.y_axes?.forEach((y_axis) => {
          if (
            graphConditionConfig?.[`date-attributes`]?.includes(
              y_axis?.attribute
            ) &&
            (!y_axis?.date_part || y_axis?.date_part === "D")
          ) {
            y_axis.date_aggregation = finalDatePart;
          }
          updatedYaxis?.push(y_axis);
        });
      }
      // to delete widget from list
      if (section_index >= 0) {
        let sectionLevel = {
          ...shareTemplateData,
          sections: shareTemplateData?.sections?.map((el, i) => {
            if (i === section_index) {
              return {
                ...el,
                widgets: el.widgets?.map((d, i) => {
                  if (i === widget_index) {
                    d.graphData = null;
                    d.persist_graphdata = null;
                    d.deep_dive_on = null;
                    return { ...d };
                  } else {
                    return { ...d };
                  }
                }),
              };
            } else {
              return { ...el };
            }
          }),
        };
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: sectionLevel,
        });
      } else {
        let sectionLevel = {
          ...shareTemplateData,
          section: shareTemplateData?.section?.map((el, i) => {
            return {
              ...el,
              widgets: el.widgets?.map((d, i) => {
                if (i === widget_index) {
                  d.graphData = null;
                  d.persist_graphdata = null;
                  d.deep_dive_on = null;
                  return { ...d };
                } else {
                  return { ...d };
                }
              }),
            };
          }),
        };
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: sectionLevel,
        });
      }
      let filter = getAllShareFilters(
        graphConditionConfig,
        shareTemplateData,
        section_index,
        widget_index,
        shareBrands
      );
      if (widgetData) {
        let duration = shareTemplateData?.duration?.from
          ? {
              from: shareTemplateData?.duration?.from
                ? shareTemplateData?.duration?.from
                : null,
              to: shareTemplateData?.duration?.to
                ? shareTemplateData?.duration?.to
                : null,
            }
          : shareTemplateData?.start_date
          ? {
              from: shareTemplateData?.start_date
                ? shareTemplateData?.start_date
                : null,
              to: shareTemplateData?.end_date
                ? shareTemplateData?.end_date
                : null,
            }
          : null;

        // Shared Dashboard Case
        let widget_metadata =
          section_index >= 0
            ? shareTemplateData?.sections?.[section_index]?.widgets?.[
                widget_index
              ]
            : shareTemplateData?.section?.[0]?.widgets?.[widget_index];

        let section_profile_filters_list =
          section_index >= 0
            ? shareTemplateData?.sections?.[section_index]?.profile_filters_list
            : shareTemplateData?.section?.[0]?.profile_filters_list;

        let widgetDefaultFilters;
        if (widget_metadata?.profile_filters_list?.length) {
          widgetDefaultFilters = {
            columns: [
              {
                name: widget_metadata?.profile_filters_list?.[0]?.id,
                type: "include",
                display_name: widget_metadata?.profile_filters_list?.[0]?.name,
                profile_channel:
                  widget_metadata?.profile_filters_list?.[0]?.channel,
                brand_id: widget_metadata?.profile_filters_list?.[0]?.brand_id,
              },
            ],
            attribute: "SocialMediaProfiles",
            type: "varchar",
          };
        }

        let sectionDefaultFilters;
        if (section_profile_filters_list?.length) {
          sectionDefaultFilters = {
            columns: [
              {
                name: section_profile_filters_list?.[0]?.id,
                type: "include",
                display_name: section_profile_filters_list?.[0]?.name,
                profile_channel: section_profile_filters_list?.[0]?.channel,
                brand_id: section_profile_filters_list?.[0]?.brand_id,
              },
            ],
            attribute: "SocialMediaProfiles",
            type: "varchar",
          };
        }
        let obj = {};
        obj.type = "share_dashboard";
        obj.section_index = section_index;
        obj.widget_index = widget_index;
        obj.data = widgetData;
        obj.shareTemplateData = shareTemplateData;
        obj.duration = duration;
        obj.filter = filter;
        obj.shareBrands = shareBrands;
        obj.profile_filters = widget_metadata?.profile_filters
          ? widget_metadata?.profile_filters
          : !widget_metadata?.profile_filters &&
            widget_metadata?.is_locked &&
            widgetDefaultFilters
          ? widgetDefaultFilters
          : section_profile_filters_list?.length && !widget_metadata?.is_locked
          ? sectionDefaultFilters
          : !widget_metadata?.is_locked && shareTemplateData?.profile_filters;
        obj.profile_filters_flag = widget_metadata?.profile_filters_flag;
        obj.data_source = widgetData?.data_source
          ? widgetData?.data_source
          : "mentions";
        obj.filter_dropdown = widget_metadata?.filter_dropdown
          ? widget_metadata?.filter_dropdown
          : [];
        obj.filter_by_dropdown = widget_metadata?.filter_by_dropdown
          ? widget_metadata?.filter_by_dropdown
          : [];
        obj.filter_by_dropdown_data = widget_metadata?.filter_by_dropdown_data
          ? widget_metadata?.filter_by_dropdown_data
          : [];

        let widgetGraphObject = getWidgetGraphObject(obj);
        widgetGraphObject.isNetworkChartV2 =
          widgetGraphObject?.chart?.chart_type === "network-graph-v2"
            ? true
            : false;
        if (widgetGraphObject && updatedXaxis) {
          widgetGraphObject.x_axis = updatedXaxis;
        }
        if (widgetGraphObject && updatedYaxis?.length) {
          widgetGraphObject.y_axes = updatedYaxis;
        }
        let indexes = {
          section_index: section_index,
          templateFilter: true,
          widget_index: widget_index,
          widget_id: widgetData?.widget_id,
          section:
            section_index >= 0
              ? shareTemplateData?.sections
              : shareTemplateData?.section,
          graph_type: widgetData?.graph_type,
          section_id:
            section_index >= 0
              ? shareTemplateData?.sections?.[section_index]?.section_id
              : shareTemplateData?.section?.[0]?.section_id,
          shareTemplateData: shareTemplateData,
        };
        let share = {
          sections: shareTemplateData,
        };
        if (section_index >= 0) {
          if (updatedXaxis) {
            shareTemplateData.sections[section_index].widgets[
              widget_index
            ].x_axis = updatedXaxis;
          }
          if (updatedYaxis?.length) {
            shareTemplateData.sections[section_index].widgets[
              widget_index
            ].y_axes = updatedYaxis;
          }

          graphConditionConfig?.[`data-source`]?.includes(
            widgetGraphObject?.data_source
          )
            ? dispatch(
                setWidgetMakerSharePageGraphData(
                  widgetGraphObject,
                  shareCategory,
                  indexes,
                  share,
                  query?.get("share_id")
                )
              )
            : dispatch(
                setWidgetMakerShareGraphData(
                  widgetGraphObject,
                  shareCategory,
                  indexes,
                  share,
                  query?.get("share_id")
                )
              );
        } else {
          if (updatedXaxis) {
            shareTemplateData.section[0].widgets[widget_index].x_axis =
              updatedXaxis;
          }
          if (updatedYaxis?.length) {
            shareTemplateData.section[0].widgets[widget_index].y_axes =
              updatedYaxis;
          }

          graphConditionConfig?.[`data-source`]?.includes(
            widgetGraphObject?.data_source
          )
            ? dispatch(
                setWidgetMakerSharePageGraphData(
                  widgetGraphObject,
                  shareCategory,
                  indexes,
                  share,
                  query?.get("share_id")
                )
              )
            : dispatch(
                setWidgetMakerShareGraphData(
                  widgetGraphObject,
                  shareCategory,
                  indexes,
                  share,
                  query?.get("share_id")
                )
              );
        }
      }
    } else {
      // view dashboard
      let finalDatePart = value === "D" ? null : value;
      let updatedXaxis;
      let updatedYaxis = [];
      if (
        graphConditionConfig?.[`date-attributes`]?.includes(
          widgetData?.x_axis?.attribute
        ) &&
        (!widgetData?.x_axis?.date_part ||
          widgetData?.x_axis?.date_part === "D")
      ) {
        updatedXaxis = {
          ...widgetData?.x_axis,
          date_aggregation: finalDatePart,
        };
      }
      if (
        graphConditionConfig?.[`date_agg-chart_type`]?.includes(
          widgetData?.chart?.chart_type || widgetData?.graph_type
        ) &&
        widgetData?.y_axes?.some(
          (y_axis) =>
            graphConditionConfig?.["date-attributes"]?.includes(
              y_axis?.attribute
            ) &&
            (!y_axis?.date_part || y_axis?.date_part === "D")
        )
      ) {
        widgetData?.y_axes?.forEach((y_axis) => {
          if (
            graphConditionConfig?.[`date-attributes`]?.includes(
              y_axis?.attribute
            ) &&
            (!y_axis?.date_part || y_axis?.date_part === "D")
          ) {
            y_axis.date_aggregation = finalDatePart;
          }
          updatedYaxis?.push(y_axis);
        });
      }
      if (widgetData) {
        let widgetObj = {
          brand_groups: widgetData?.brand_groups,
          singleBrands: brands,
        };
        let filter = getAllFilters(
          graphConditionConfig,
          panes,
          index,
          section_index,
          widget_index,
          brandlogicalgroup,
          widgetData?.brand_ids, //logical brand change
          widgetObj
        );
        let duration = panes[index]?.duration;
        // let global_brands = getGlobalBrands(
        //   panes[index]?.brands,
        //   global_dashboard_single_brands,
        //   global_dashboard_brands,
        //   panes[index]?.template_type
        // );
        let global_brands = panes?.[index]?.brands;
        let indexes = {
          pane_index: index,
          section_index: section_index >= 0 ? section_index : null,
          panes: panes,
          widget_index: widget_index,
          widget_id: widgetData?.widget_id,
          graph_type: widgetData?.graph_type,
          section_id:
            section_index >= 0
              ? panes?.[index]?.sections?.[section_index]?.section_id
              : panes?.[index]?.section?.[0]?.section_id,
        };

        // View Dashboard Profile FIlter case
        let widget_metadata =
          section_index >= 0
            ? panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
            : panes?.[index]?.section?.[0]?.widgets?.[widget_index];

        let widget_profile_filter_list =
          section_index >= 0
            ? panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
                ?.profile_filters_list
            : panes?.[index]?.section?.[0]?.widgets?.[widget_index]
                ?.profile_filters_list;

        let section_profile_filter_list =
          section_index >= 0
            ? panes?.[index]?.sections?.[section_index]?.profile_filters_list
            : panes?.[index]?.section?.[0]?.profile_filters_list;

        let obj = {};
        obj.section_index = section_index;
        obj.widget_index = widget_index;
        obj.data = widgetData;
        obj.panes = panes;
        obj.paneIndex = index;
        obj.duration = duration;
        obj.global_brands = global_brands;
        obj.filter = filter;
        obj.brandlogicalgroup = brandlogicalgroup;
        obj.brands = brands;
        obj.authParams = authParams;
        obj.type = "view";
        obj.profile_filters = widget_metadata?.profile_filters
          ? widget_metadata?.profile_filters
          : null;
        obj.profile_filters_list =
          widget_metadata?.is_locked && widget_profile_filter_list?.length > 0
            ? widget_profile_filter_list
            : section_profile_filter_list?.length > 0
            ? section_profile_filter_list
            : profileFilterList;
        obj.profile_filters_flag = widget_metadata?.profile_filters_flag;
        obj.data_source = widgetData?.data_source
          ? widgetData?.data_source
          : "mentions";

        obj.filter_dropdown = widget_metadata?.filter_dropdown
          ? widget_metadata?.filter_dropdown
          : [];
        obj.filter_by_dropdown = widget_metadata?.filter_by_dropdown
          ? widget_metadata?.filter_by_dropdown
          : [];
        obj.filter_by_dropdown_data = widget_metadata?.filter_by_dropdown_data
          ? widget_metadata?.filter_by_dropdown_data
          : [];

        let widgetGraphObject = getWidgetGraphObject(obj);
        widgetGraphObject.isNetworkChartV2 =
          widgetGraphObject?.chart?.chart_type === "network-graph-v2"
            ? true
            : false;

        if (widgetGraphObject && updatedXaxis) {
          widgetGraphObject.x_axis = updatedXaxis;
        }
        if (widgetGraphObject && updatedYaxis?.length) {
          widgetGraphObject.y_axes = updatedYaxis;
        }
        if (section_index >= 0) {
          if (updatedXaxis) {
            panes[index].sections[section_index].widgets[widget_index].x_axis =
              updatedXaxis;
          }
          if (updatedYaxis?.length) {
            panes[index].sections[section_index].widgets[widget_index].y_axes =
              updatedYaxis;
          }
          if (
            graphConditionConfig?.[`data-source`]?.includes(
              widgetData?.data_source
            )
          ) {
            dispatch(setPageChart(authParams, widgetGraphObject, indexes));
          } else {
            dispatch(
              setWidgetMakerGraphData(authParams, widgetGraphObject, indexes)
            );
          }
        } else {
          if (updatedXaxis) {
            panes[index].section[0].widgets[widget_index].x_axis = updatedXaxis;
          }
          if (updatedYaxis?.length) {
            panes[index].section[0].widgets[widget_index].y_axes = updatedYaxis;
          }
          if (
            graphConditionConfig?.[`data-source`]?.includes(
              widgetData?.data_source
            )
          ) {
            dispatch(setPageChart(authParams, widgetGraphObject, indexes));
          } else {
            dispatch(
              setWidgetMakerGraphData(authParams, widgetGraphObject, indexes)
            );
          }
        }
      }
    }
  };

  const handleDropdownVisibleChange = (value) => {
    if (!value) {
      dateAggregationRef?.current.blur();
    }
  };
  return (
    <>
      {widgetData?.x_axis?.attribute === "FLRBenchmark" &&
      (typeof widgetData?.data === "object" ||
        typeof widgetData?.graphData === "object") ? (
        <span className="text-nowrap text_regular ml-2">FLR Benchmark</span>
      ) : widgetData?.x_axis?.attribute === "ResolutionBenchmark" &&
        (typeof widgetData?.data === "object" ||
          typeof widgetData?.graphData === "object") ? (
        <span className="text-nowrap text_regular ml-2">
          Resolution Benchmark
        </span>
      ) : (
        ""
      )}
      {
        <Tooltip
          title={`${
            personalizationSettingsObj?.isPersonalizationPreviewOpen
              ? "Cannot perform action while customizing screen"
              : ""
          }`}
          placement="bottom"
        >
          <div className="d-flex align-items-center">
            <Select
              ref={dateAggregationRef}
              popupClassName={
                authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
              }
              showArrow={true}
              onDropdownVisibleChange={handleDropdownVisibleChange}
              className="ml-2 ticketOverView"
              suffixIcon={
                // <img
                //   src={
                //     authParams?.theme_type === "1" ? accoArrowWhite : accoArrow
                //   }
                //   className="accordionArrow p-0"
                //   alt="accoArrow"
                // />
                <span className="accordionArrow d-flex align-items-center p-0">
                  {" "}
                  {authParams?.theme_type === "1"
                    ? getDynamicIconColor("accordion_arrow_white")
                    : getDynamicIconColor("accordion_arrow")}
                </span>
              }
              bordered={false}
              defaultValue={
                updatedDateAgg
                  ? updatedDateAgg
                  : updatedDateAgg === null
                  ? "D"
                  : defaultOption
              }
              value={
                updatedDateAgg
                  ? updatedDateAgg
                  : updatedDateAgg === null
                  ? "D"
                  : defaultOption
              }
              style={{
                width:
                  updatedDateAgg === "M"
                    ? "100%"
                    : updatedDateAgg === "ww"
                    ? "100%"
                    : "100%",
              }}
              onChange={(e) =>
                handleChangeDuration(e, widgetData, section_index, widget_index)
              }
              disabled={
                personalizationSettingsObj?.isPersonalizationPreviewOpen ??
                disabled
              }
            >
              {widgetData?.x_axis?.attribute === "FLRBenchmark" ||
              widgetData?.x_axis?.attribute === "ResolutionBenchmark" ? (
                <>
                  {optionList?.map((list, i) => {
                    return (
                      <Option value={list} key={i}>
                        {(list === 5 && "5 mins") ||
                          (list === 10 && "10 mins") ||
                          (list === 15 && "15 mins") ||
                          (list === 30 && "30 mins") ||
                          (list === 60 && "1 hr") ||
                          (list === 120 && "2 hrs") ||
                          (list === 4 * 60 && "4 hrs") ||
                          (list === 8 * 60 && "8 hrs") ||
                          (list === 16 * 60 && "16 hrs") ||
                          (list === 24 * 60 && "24 hrs") ||
                          (list === 48 * 60 && "48 hrs")}
                      </Option>
                    );
                  })}
                </>
              ) : (
                optionList?.map((list, i) => {
                  return (
                    <Option value={list} key={i}>
                      {(list === "1h" && "1 hr") ||
                        (list === "2h" && "2 hrs") ||
                        (list === "3h" && "3 hrs") ||
                        (list === "4h" && "4 hrs") ||
                        (list === "6h" && "6 hrs") ||
                        (list === "8h" && "8 hrs") ||
                        (list === "12h" && "12 hrs") ||
                        (list === "D" && "Daily") ||
                        (list === "M" && "Monthly") ||
                        (list === "ww" && (
                          <>
                            {widgetData?.data_source === "ticket" ? (
                              <span title="Weekly">Weekly</span>
                            ) : (
                              <span title="Week of Year">Week of Year</span>
                            )}
                          </>
                        )) ||
                        (list === "Y" && "Yearly")}
                    </Option>
                  );
                })
              )}
            </Select>
          </div>
        </Tooltip>
      }
    </>
  );
};

export default React.memo(DateAggregation, isEqual);
